"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppIcon = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_2 = __importDefault(require("@mdi/react"));
var App_1 = require("../../App");
var IconContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    transform: translateY(-3px);\n    z-index: 10;\n  }\n"], ["\n  &:hover {\n    transform: translateY(-3px);\n    z-index: 10;\n  }\n"])));
var AppIcon = function (props) {
    var theme = (0, App_1.useEloise)().theme;
    return (react_1.default.createElement(IconContainer, { className: props.className ? props.className : "", onClick: function () {
            props.onClick();
        } },
        react_1.default.createElement(react_2.default, { path: props.icon, style: {
                borderRadius: "3px",
                margin: "auto",
            }, title: props.title, size: props.size ? props.size : 1.6, color: props.color ? props.color : theme.mode == "dark" ? props.inverse ? "black" : "white" : props.inverse ? "white" : "black" })));
};
exports.AppIcon = AppIcon;
var templateObject_1;
